import { SerializedError } from './serializeError';

const expectedErrorKeys = ['detail', 'message', 'reason', 'error'] as const;

export const findErrorMessage = (parsed: any): string => {
  if (parsed) {
    if (Array.isArray(parsed)) return findErrorMessage(parsed[0]);
    if (typeof parsed === 'string') return parsed;
    if (typeof parsed === 'object') {
      for (let i = 0; i < expectedErrorKeys.length; i += 1) {
        const value = parsed[expectedErrorKeys[i]];
        if (value) return findErrorMessage(value);
      }

      return findErrorMessage(Object.values(parsed)[0]);
    }
  }

  return null;
};

export const parseErrorMessage = (message: string): string => {
  if (!message) return message;
  try {
    return findErrorMessage(JSON.parse(message)) || message;
  } catch (e) {
    return message;
  }
};

export const parseError = (error: SerializedError): string => {
  if (!error) return null;
  if (error.response?.responseText) return parseErrorMessage(error.response.responseText);
  if (error.response?.statusText) return parseErrorMessage(error.response.statusText);
  return parseErrorMessage(error.message);
};

// Some entity actions (e.g. updateAdminOrganization, updateAdminEvent) are shared across multiple
// unrelated forms on the same screen, so their `updatingError` slot can hold an error from a
// different field's concurrent/last save. Use this to confirm a DRF-style field error (e.g.
// {"slug": ["..."]}) actually mentions the field before attributing it to that field's input.
export const hasFieldError = (error: SerializedError, field: string): boolean => {
  if (!error?.response?.responseText) return false;
  try {
    const parsed = JSON.parse(error.response.responseText);
    return typeof parsed === 'object' && parsed !== null && field in parsed;
  } catch (e) {
    return false;
  }
};
